import { render } from "./GoalsComponent.vue?vue&type=template&id=92f0ec94&scoped=true"
import script from "./GoalsComponent.vue?vue&type=script&lang=js"
export * from "./GoalsComponent.vue?vue&type=script&lang=js"

import "./GoalsComponent.vue?vue&type=style&index=0&id=92f0ec94&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f0ec94"]])

export default __exports__